
import React from 'react';


import {
} from '../../api/methodPayment.api';

import {connect} from 'react-redux';
import toastr from 'toastr';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';
import { loftyHandleCountShoppingCart } from '../../util/handleCount';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';


import './exitosochambometroygrit.scss';


// Hamburger
function loftyInitHam() {
  try {
  // eslint-disable-next-line no-restricted-globals
    window.addEventListener('click', (event) => {
      let originPointLeft = '';
      const comp = event.target.className;
      if (comp.includes('menu__btn') || comp.includes('span_middle') || comp.includes('span_before') || comp.includes('span_after')) {
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        spanData.forEach((item) => {
          originPointLeft = item.style.left;
        });
        res.forEach((item) => {
          item.style.left = '0px';
        });
        spanData.forEach((item) => {
          item.style.left = '-300px';
        });
        closeBtn.forEach((item) => {
          item.style.left = '10px';
        });
      } else {
        if (comp === 'menu__box') {
          return;
        }
        if (comp === 'linkshref') {
          return;
        }
        if (comp === 'menu__item') {
          return;
        }
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        res.forEach((item) => {
          item.style.left = '-300px';
        });
        spanData.forEach((item) => {
          item.style.left = originPointLeft;
        });
        closeBtn.forEach((item) => {
          item.style.left = '-100%';
        });
      }
    });
  } catch (error) {
    // console.log(error);
  }
}    
    






const Pexitosochambometroygrit = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {






  
  setTimeout(() => { loftyInitHam(); }, 2000);

  
  

  
  return (
    <div id="id6911fb968e5aed52dc85295c" >

      <div id="ii5j" className="">
      
      <div id="i2wm" className="">
      
      <div id="i3to" className="">
      
      <div id="i4zac" className="">
      
      <div id="i7ltfh" className="">
      
      <div id="iq3oci" className="">
      
        <a
          target="_blank"
          className="redes-sociales "
          id="iyoins"
          href="https://www.facebook.com/share/1MZa4kJbWJ/"
        >
          
      <img
        className=""
        id="iqxn7c"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnx0u9w.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        
        <a
          target="_blank"
          className="redes-sociales "
          id="iup45h"
          href="https://x.com/chambahonduras?t=paP02Yu8E246utuee6OmXA&s=09"
        >
          
      <img
        className=""
        id="iyzeef"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnx2duv.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        
        <a
          target="_blank"
          className="redes-sociales "
          id="if3occ"
          href="https://www.instagram.com/chamba.hn?igsh=MWdzNTRtZDRqOXN3MQ=="
        >
          
      <img
        className=""
        id="i3pbhl"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnx2wo7.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        
        <a
          target="_blank"
          className="redes-sociales "
          id="irgcil"
          href="https://www.youtube.com/@ChambaHonduras"
        >
          
      <img
        className=""
        id="iro1nx"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnx35nw.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        <>
        </>
      </div>
      
      <div id="ik5ary" className="">
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="istkj" className="">
      
      <div id="ivpj2" className="">
      
        <LoftyDropdownComponent
          id="idps4e"
          className="gjs-dropdown-menu-container "
          childrenShow={
            <>
              <div id="iqkyvo" className="gjs-dropdown-menu-trigger link-navegacion ">
<>Ecosistema chamba
        </></div>

            </>
          }
          childrenHover={
            <>
              <div id="iuszg2" className="gjs-dropdown-menu-content " style={{display: 'block'}}>

        <a
          target=""
          className="link-navegacion "
          id="i0llh"
          href="/index"
        >
          
    <div id="ij1vq" className="">
    <>Chamba Index</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-navegacion "
          id="iwy3cg"
          href="/chambanomics"
        >
          
    <div id="ike6o9" className="">
    <>Chambanomics</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-navegacion "
          id="i68lj"
          href="/chambometro"
        >
          
    <div id="inisp" className="">
    <>Chambómetro Electoral</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-navegacion "
          id="iog9i6"
          href="/talks"
        >
          
    <div id="iogkoj" className="">
    <>Chamba talks</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-navegacion "
          id="ievl0d"
          href="/chambeador"
        >
          
    <div id="i40bdb" className="">
    <>Chambeador del año</>
    </div>
    
        </a>
        </div>

            </>
          }
        />
        
        <a
          target=""
          className="link-navegacion "
          id="ilnkvn"
          href="/fundacion"
        >
          
    <div id="iv451u" className="">
    <>Fundación</>
    </div>
    
        </a>
        <>
        </>
      </div>
      
      <div id="iaa1w" className="">
      
        <a
          target=""
          className=""
          id="iemvlw"
          href="/"
        >
          
      <img
        className=""
        id="ilkbh"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnx82cj.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        <>
        </>
      </div>
      
      <div id="i4z2t" className="">
      
        <a
          target=""
          className="link-navegacion "
          id="ijedtq"
          href="/sobrenosotros"
        >
          
    <div id="in2vnm" className="">
    <>Sobre nosotros</>
    </div>
    
        </a>
        
        <a
          target="_blank"
          className="link-navegacion "
          id="ir6ulk"
          href="https://cne.chamba.hn/"
        >
          
    <div id="i4ijnp" className="">
    <>Centro electoral</>
    </div>
    
        </a>
        <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="i23lgf" className="">
      
      <img
        className=""
        id="iaxk7b"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnx82cj.png"
        alt="undefined"
      />
      
      <div id="" className="contentwrapperanimated ">
      
      <div id="" className="container_animated ">
      
      <label id="" className="menu__btn ">
      
      <span className="span_before " id="">
        
      </span>
      
      <span className="span_middle " id="">
        
      </span>
      
      <span className="span_after " id="">
        
      </span>
      
      </label>
      
      <label id="" className="menu__close__btn ">
      
      <span className="span__close__left " id="">
        
      </span>
      
      <span className="span__close__right " id="">
        
      </span>
      
      </label>
      
      <ul id="" className="menu__box ">
        
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/"
        type=""
      >
        <>Inicio</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/sobrenosotros"
        type=""
      >
        <>Sobre nosotros</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/index"
        type=""
      >
        <>Chamba Index</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/talks"
        type=""
      >
        <>Chamba Talks</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/fundacion"
        type=""
      >
        <>Fundación</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/chambometro"
        type=""
      >
        <>Chambómetro</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/chambeador"
        type=""
      >
        <>Chambeador del año</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/agregarcv"
        type=""
      >
        <>Postular</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      </li>
      
      <li className="linkshref " id="">
        
      </li>
      
      </ul>
      
      </div>
      
      </div>
      <>
        </>
      </div>
      
      <div
        id="isa7id"
        className=""
        data-aos="fade-up"
        data-aos-duration="2000"
      >
      
      <div id="i9x2g" className="">
      
      <div className="" id="im8zk">
        <>Gracias por tu registro en Chambómetro Electoral</>
      </div>
      <>
        </>
      </div>
      
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="i8g6" className="">
      
      <img
        className=""
        id="izriq"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnxjnni.png"
        alt="undefined"
      />
      
      <div
        id="i9enf4"
        className=""
        data-aos="fade-down"
        data-aos-duration="2000"
      >
      
      <div id="i7inz" className="">
      
      <div className="" id="ijluj">
        <>Tu registro se ha completado con éxito.</>
      <br className="" id="" />
      <>Nos alegra mucho tenerte con nosotros — pronto recibirás las últimas novedades, oportunidades y contenido exclusivo directamente en tu correo.</>
      </div>
      <>
        </>
      </div>
      
      <div id="iyolrf" className="">
      
        <a
          target=""
          className="boton-secundario "
          id="iv4m6e"
          href="/"
        >
          
      <span className="" id="i0glfp">
        <>Ir a la página principal</>
      </span>
      
        </a>
        <>
        </>
      </div>
      
      </div>
      <>
        </>
      </div>
      
      <div id="im78" className="">
      
      <div id="imr134" className="">
      
      <div id="i3kmzi" className="">
      
      <img
        className=""
        id="ijd9oi"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnx82cj.png"
        alt="undefined"
      />
      
      <div className="" id="ii039l">
        <>En CHAMBA creemos que el verdadero cambio comienza cuando las personas tienen oportunidades reales. No hablamos de discursos, hablamos de empleo, educación responsabilidad fiscal, libre mercado y gobierno limitado. Nuestro propósito es conectar a los hondureños que quieren salir adelante con las herramientas, la información y las redes que pueden hacerlo posible.</>
      </div>
      <>
        </>
      </div>
      
      <div id="igpnrp" className="">
      
      <div className="" id="iwmzhr">
        <>Siguenos</>
      </div>
      
      <div id="ii0mf" className="">
      
        <a
          target="_blank"
          className="redes-sociales "
          id="igd3x"
          href="https://www.facebook.com/share/1MZa4kJbWJ/"
        >
          
      <img
        className=""
        id="ivqnc"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnx0u9w.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        
        <a
          target="_blank"
          className="redes-sociales "
          id="i5j0k"
          href="https://x.com/chambahonduras?t=paP02Yu8E246utuee6OmXA&s=09"
        >
          
      <img
        className=""
        id="ibnrn"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnx2duv.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        
        <a
          target="_blank"
          className="redes-sociales "
          id="ir76u"
          href="https://www.instagram.com/chamba.hn?igsh=MWdzNTRtZDRqOXN3MQ=="
        >
          
      <img
        className=""
        id="imcck"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnx2wo7.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        
        <a
          target="_blank"
          className="redes-sociales "
          id="izuti"
          href="https://www.youtube.com/@ChambaHonduras"
        >
          
      <img
        className=""
        id="iyz7f"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnx35nw.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div className="" id="id4zm3">
        <>© 2025 CHAMBA. Todos los derechos reservados.</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pexitosochambometroygrit);
  